import { PapiDeviation } from '@wix/da-types-papi';

export enum BackgroundType {
  NONE = 'none',
  SOLID = 'solid',
  GRADIENT = 'gradient',
  PATTERN = 'pattern',
  IMAGE = 'image',
}

export enum BackgroundImageDisplayMode {
  TILE = 'tile',
  COVER = 'cover',
  CONTAIN = 'contain',
}

export type ConfigOption = {
  id: number;
  value: string;
  selected?: boolean;
};

export type BackgroundConfig = {
  color?: string;
  gradient?: number;
  pattern?: string;
  backgroundType?: BackgroundType;
  imageDisplayMode?: BackgroundImageDisplayMode;
  imageTint?: string;
  image?: PapiDeviation;
};
